export class HamburgerMenu{
	init(){
		var $mobileNav 		= $('.mobile-nav'),
				$hamburger 		= $('.js-mobile-nav'),
				$navElements 	= $mobileNav.find('.mobile-nav__content li');


		$('.js-mobile-nav').on('click', function(){
			$hamburger.toggleClass('is-active');
			$mobileNav.fadeToggle(function(){
				if($mobileNav.is(':visible')){
					for( var i=0; i<$navElements.length; i++ ){
						$($navElements[i]).css({'transition-delay': (i * 50)+'ms'}).addClass('fadeIn');
					}
				}else{
					$navElements.removeClass('fadeIn');
				}
			});

		});
	}
}